<div class="los-wrapper">

  <div
    class="top-nav d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-white"
  >
    <div class="logo">
      <img
        src="assets/images/Logo.svg"
        alt="Logo"
        class="img-fluid"
        style="height: 40px"
      />
    </div>
  </div>

  <!-- ══ STEPPER ══ -->
  <div class="los-stepper">
    <div
      class="st"
      *ngFor="let step of steps; let i = index"
      [class.active]="i === currentStep"
      [class.done]="i < currentStep"
      [class.locked]="!canNavigateToStep(i)"
      (click)="goToStep(i)"
    >
      <div class="st-bub">
        <span *ngIf="i < currentStep">✓</span>
        <span *ngIf="i >= currentStep">{{ i + 1 }}</span>
      </div>
      <div class="st-lbl">{{ step }}</div>
    </div>
  </div>

  <!-- ══ PROGRESS BAR ══ -->
  <div class="los-prog-wrap">
    <div class="los-prog-bar">
      <div class="los-prog-fill"
        [style.width.%]="((currentStep + 1) / steps.length) * 100">
      </div>
    </div>
    <div class="los-prog-pct">{{ ((currentStep + 1) / steps.length * 100) | number:'1.0-0' }}%</div>
  </div>

  <!-- ══ STEP CONTENT ══ -->
  <div class="los-content">

    <div *ngIf="isLoading" style="padding:40px;text-align:center">
      <div class="spinner-border text-primary" role="status"></div>
      <div style="margin-top:12px;color:#8b949e;font-size:13px">Loading application context...</div>
    </div>

    <ng-container *ngIf="!isLoading">
      <app-application-create *ngIf="currentStep === 0" (next)="nextStep()"></app-application-create>
      <app-user-consent       *ngIf="currentStep === 1" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-user-consent>
      <app-user-kyc           *ngIf="currentStep === 2" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-user-kyc>
      <app-financial          *ngIf="currentStep === 3" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-financial>
      <app-bureau-aa          *ngIf="currentStep === 4" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-bureau-aa>
      <app-credit-decision    *ngIf="currentStep === 5" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-credit-decision>
      <app-bo-review          *ngIf="currentStep === 6" (next)="nextStep()" (prev)="prevStep()"></app-bo-review>
      <app-kfs-delivery       *ngIf="currentStep === 7" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-kfs-delivery>
      <app-e-stamp            *ngIf="currentStep === 8" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-e-stamp>
      <app-e-sign             *ngIf="currentStep === 9" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-e-sign>
      <app-e-mandate          *ngIf="currentStep === 10" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-e-mandate>
      <app-disbursal-ready    *ngIf="currentStep === 11" [applicationId]="applicationId" (next)="nextStep()" (prev)="prevStep()"></app-disbursal-ready>
      <app-disbursed          *ngIf="currentStep === 12" [applicationId]="applicationId" (prev)="prevStep()"></app-disbursed>
    </ng-container>

  </div>

</div>
